/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.AssignedContentChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllAssignedUserProgressRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.AssignedContentChirpService',
  rpcName: 'getAllAssignedUserProgress',
  auth: 'app',
  fingerprint: 'OEx5Sx3qPh69Ns6d7BcJU5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllAssignedContentForPortalRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.AssignedContentChirpService',
  rpcName: 'getAllAssignedContentForPortal',
  auth: 'app',
  fingerprint: '-RFfhhyTn4rII8OxJ0xkvZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};